<template>
<div>
    <nav class="mx-4 border-b border-gray-dark md:flex md:justify-between md:items-end">
        <h2 class="md:w-1/4 font-bold text-xl px-4 py-4 flex items-baseline justify-between">
            Daily Digest
            <p-check class="text-base ml-2 p-switch p-fill flex-shrink md:hidden" color="primary" v-model="isOn" @change="toggleFilterStatus"></p-check>
        </h2>
        <nav class="md:w-2/4 md:text-center uppercase text-xs pb-4">
            <a href="#review" @click.prevent="onNav('review')" class="p-4" :class="hasNav('review') ? 'border-primary border-b-2 font-bold text-primary' : ''">Review</a>
            <a href="#history" @click.prevent="onNav('history')" class="p-4" :class="hasNav('history') ? 'border-primary border-b-2 font-bold text-primary' : ''">History</a>
        </nav>
        <div class="md:w-1/4 hidden md:block">
            <p class="p-4 flex justify-end">
                <p-check class="p-switch p-fill flex-shrink" color="primary" v-model="isOn" @change="toggleFilterStatus"></p-check>
            </p>
        </div>
    </nav>
    <keep-alive>
        <div :is="component"></div>
    </keep-alive>
</div>
</template>

<script>
import ReviewerTipsModal from './ReviewerTipsModal.vue';

export default {
    data() {
        return {
            isOn  : true,
            active: 'review'
        }
    },
    mounted() {
        axios.get('/api/mailbox')
        .then(response => {
            this.isOn = response.data.data.is_filtering_spam;
        })
        .catch(err => console.error);

        this.navigateUsingURL();

        window.addEventListener('popstate', (event) => {
            if (event.state) {
                this.setNav(event.state.url.slice(1)); // .slice(1) removes the leading '#'
            } else this.navigateUsingURL();
        });
    },
    computed: {
        component() {
            switch (this.active) {
                case 'review':
                    return 'reviewer-review';
                    break;

                case 'history':
                    return 'zap-zone-history';
                    break;

                default:
                    break;
            }
        }
    },
    methods: {
        navigateUsingURL() {
            if (!window.location.hash) {
                // Shows the default.
                this.onNav(this.active);
            } else {
                this.onNav(window.location.hash.slice(1)); // .slice(1) removes the leading '#'
            }
        },
        onNav(to) {
            var stateObject = {'url' : `#${to}`};

            if (window.location.hash && stateObject.url !== window.location.hash) {
                window.history.pushState(stateObject, document.title, window.location.pathname + stateObject.url);
            } else {
                window.history.replaceState(stateObject, document.title, window.location.pathname + stateObject.url);
            }

            this.setNav(to);
        },
        setNav(to) {
            this.active = to;
        },
        hasNav(active) {
            return this.active === active;
        },
        showReviewerTips() {
            Modal.show(ReviewerTipsModal);
        },
        toggleFilterStatus(isOn) {
            axios.put('/api/mailbox', {
                is_filtering_spam: isOn,
            })
            .then(response => {
                const message = isOn
                    ? 'Great! Spammy emails will be held back for your review.'
                    : 'Great! All emails will be delivered to your inbox.';
                Event.$emit('toast', {text: message});
            })
            .catch(err => {
                if (err.response.data?.message) {
                    this.isOn = !this.isOn;
                    Event.$emit('toast', {
                        text: err.response.data?.message,
                        type: 'danger',
                    });
                }
                console.error(err);
            })
        },
    }
}
</script>
